import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import Layout from "../../components/Shared/Layout/Layout";
import StatCard from "../../components/Shared/StatCard/StatCard";
import { BiMessageSquareDetail } from "react-icons/bi";
import ContactMessageList from "../../components/ContactMessageList/ContactMessageList";
import { useEffect } from "react";
import { getContacts } from "../../actions/contact.action";
import { connect } from "react-redux";

const AdminContactPage = ({ contacts, getContacts }) => {
  useEffect(() => {
    if (!contacts) {
      getContacts();
    }
  }, []);
  return (
    <Layout title="Contact">
      {contacts === null ? (
        <Spinner animation="grow" variant="dark" />
      ) : (
        <>
          <Row className="d-flex justify-content-start pt-4">
            <Col md={6}>
              <StatCard
                title="Total Messages"
                icon={<BiMessageSquareDetail size={"1.2em"} />}
                count={contacts.length}
              />
            </Col>
          </Row>
          <ContactMessageList contacts={contacts} />
        </>
      )}
    </Layout>
  );
};
const mapStateToProps = (state) => ({
  contacts: state.auth.contact,
});

export default connect(mapStateToProps, { getContacts })(AdminContactPage);
